import { z } from "zod";
/** Defines event data that will be sent to and from Google Calendars */
export var Events;
(function (Events) {
    let EventType;
    (function (EventType) {
        EventType["Training"] = "training";
        EventType["Boarding"] = "boarding";
        EventType["PickupDropoff"] = "pickup-dropoff";
    })(EventType = Events.EventType || (Events.EventType = {}));
    ;
    let TrainingType;
    (function (TrainingType) {
        TrainingType["Fundamentals"] = "fundamentals";
        TrainingType["Executive"] = "executive";
        TrainingType["Advanced"] = "advanced";
        TrainingType["Test"] = "test";
    })(TrainingType = Events.TrainingType || (Events.TrainingType = {}));
    ;
    let FundamentalsType;
    (function (FundamentalsType) {
        FundamentalsType["ThreeWeeks"] = "three-weeks";
    })(FundamentalsType = Events.FundamentalsType || (Events.FundamentalsType = {}));
    let ExecutiveType;
    (function (ExecutiveType) {
        ExecutiveType["TwelveWeeks"] = "twelve-weeks";
    })(ExecutiveType = Events.ExecutiveType || (Events.ExecutiveType = {}));
    ;
    let AdvancedType;
    (function (AdvancedType) {
        AdvancedType["FourWeeks"] = "four-weeks";
        AdvancedType["SixWeeks"] = "six-weeks";
        AdvancedType["EightWeeks"] = "eight-weeks";
    })(AdvancedType = Events.AdvancedType || (Events.AdvancedType = {}));
    ;
    Events.EventTypeMap = {
        training: "Training",
        boarding: "Boarding",
        "pickup-dropoff": "Pickup / Drop Off"
    };
    Events.TrainingTypeMap = {
        fundamentals: "Fundamentals Training",
        executive: "Executive Training",
        advanced: "Advanced Training",
        test: "test"
    };
    Events.FundamentalsTypeMap = {
        "three-weeks": "Three Week Program",
    };
    Events.ExecutiveTypeMap = {
        "twelve-weeks": "Twelve Week Program",
    };
    Events.AdvancedTypeMap = {
        "four-weeks": "Four Week Program",
        "six-weeks": "Six Week Program",
        "eight-weeks": "Eight Week Program",
    };
    Events.EventTypeSchema = z.nativeEnum(EventType);
    Events.TrainingTypeSchema = z.nativeEnum(TrainingType);
    Events.FundamentalsTypeSchema = z.nativeEnum(FundamentalsType);
    Events.ExecutiveTypeSchema = z.nativeEnum(ExecutiveType);
    Events.AdvancedTypeSchema = z.nativeEnum(AdvancedType);
    ;
    ;
    function isAppEvent(m) {
        return 'dogId' in m;
    }
    Events.isAppEvent = isAppEvent;
    /** @deprecated Events are stored in Google Calendar, not firestore */
    Events.Collection = null;
})(Events || (Events = {}));
//# sourceMappingURL=index.js.map